const LayoutSettings = {
  leftSidebar: {
    show: true,
    mode: 'full', // full, close, compact, mobile,
    theme: 'follow', // View all valid theme colors inside FollowGreenTheme/themeColors.js
    // bgimgurl: '/assets/images/demo_all.jpg',
  },
  topbar: {
    show: true,
    fixed: true,
    theme: 'whiteBlue', // View all valid theme colors inside FollowGreenTheme/themeColors.js
  },
};

export default LayoutSettings;
